exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!bootstrap/dist/css/bootstrap.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!devextreme/dist/css/dx.common.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!devextreme/dist/css/dx.light.compact.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\nbody {\n    padding-top: 1rem;\n}\n.starter-template {\n    padding: 3rem 1.5rem;\n    text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/node_modules/postcss-loader?{"ident":"postcss"}!C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles